import { ACTIONS } from '../../constants';
import { IHeaderState, THeaderActions } from './types';

const initialState: IHeaderState = {
  isEnable: false,
  announcement: undefined,
  onlineAgents: [],
  hideStatusBanner: false,
};

export const headerReducer = (
  state = initialState,
  action: THeaderActions,
): IHeaderState => {
  switch (action.type) {
    case ACTIONS.ENABLE_BUTTON: {
      return {
        ...state,
        isEnable: action.data,
      };
    }

    case ACTIONS.CHAT_RESET: {
      return {
        ...state,
        isEnable: false,
        onlineAgents: [],
      };
    }

    case ACTIONS.HIDE_ALERT: {
      return {
        ...state,
        announcement: undefined,
      };
    }

    case ACTIONS.LEFT_AGENT: {
      const { id } = action.payload;

      return {
        ...state,
        onlineAgents: state.onlineAgents.filter((agent) => {
          return agent.id !== id;
        }),
      };
    }

    case ACTIONS.RESET_STATUS_BANNER_DATA: {
      return {
        ...state,
        statusBanner: undefined,
        hideStatusBanner: true,
      };
    }

    case ACTIONS.SET_STATUS_BANNER_DATA: {
      return {
        ...state,
        statusBanner: action.payload,
      };
    }

    case ACTIONS.JOINED_AGENT: {
      const { id } = action.payload;

      const index = state.onlineAgents.findIndex((agent) => {
        return agent.id === id;
      });

      if (index > -1) {
        return state;
      }

      return {
        ...state,
        onlineAgents: state.onlineAgents.concat(action.payload),
      };
    }

    case ACTIONS.CHAT_CHANGE_MODE: {
      if (action.isLiveChat) {
        return state;
      }

      return {
        ...state,
        onlineAgents: [],
      };
    }

    default:
      return state;
  }
};
